import { Box, Button, IconButton, Typography, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { theme } from "app/App";
import { Children, cloneElement, useEffect, useState } from "react";
import Fieldset from "components/form/Fieldset";
import { NestedField, useFieldValue } from "../NestedField";
import "./ListInput.css";

/**
 * TODO: comentar
 *
 * Os rótulos dos campos são inferidos pelo prop.label de cada input, mas pode
 * ser sobrescrito especificando o array fieldLabels.
 */
export default function ListInput({ name, label, labelButton, fieldLabels, onAdd, onRemove, fullWidth, sx, children }) {
    let smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    let [items, setItems] = useFieldValue(name);

    items ||= [];

    const [labels, setLabels] = useState([]);
    const [fields, setFields] = useState([]);

    useEffect(() => {
        let newLabels = [];
        let newFields = [];

        if (!smallScreen) {
            if (fieldLabels) {
                newLabels = fieldLabels;
            }

            for (const child of Children.toArray(children)) {
                newLabels.push(child.props.label);
                newFields.push(cloneElement(child, { label: null }));
            }
        } else {
            newFields = children;
        }

        setLabels(newLabels);
        setFields(newFields);
    }, [children, fieldLabels, smallScreen]);

    function addItem() {
        const newItem = {};
        setItems([...items, newItem]);

        if (onAdd) {
            onAdd(newItem);
        }
    }

    function removeItem(index) {
        const removed = items.splice(index, 1)[0];
        setItems([...items]);

        if (onRemove) {
            onRemove(removed, index);
        }
    }

    const addButton = (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={() => addItem()}>
                {labelButton || "Adicionar"}
            </Button>
        </Box>
    );

    return (
        <Fieldset className="ListInput" label={label} fullWidth={fullWidth}>
            {smallScreen ? null : addButton}

            <Box
                sx={{
                    "& table": { width: "100%", borderCollapse: "collapse" },
                    "& td": { p: 1 },
                    "& td > *": { width: "100%", height: "100%" },
                    "& td:nth-of-type(even)": { backgroundColor: theme.palette.grey[100] },
                    "& td:last-child": { backgroundColor: "inherit" },
                }}
            >
                <table>
                    {smallScreen ? null : (
                        <thead>
                            <tr>
                                {labels.map((label, index) => (
                                    <td key={index}>
                                        <Typography variant="caption">{label}</Typography>
                                    </td>
                                ))}
                                <td />
                            </tr>
                        </thead>
                    )}

                    <tbody>
                        {items.map((item, index) => (
                            <NestedField key={index} prefix={name} index={index}>
                                <tr>
                                    {fields.map ? fields.map((field, index) => (
                                        <td valign="bottom" key={index}>
                                            {field}
                                        </td>
                                    )) : <td valign="bottom" key={index}>
                                        {fields}
                                    </td>}

                                    <td valign="bottom">
                                        <IconButton onClick={() => removeItem(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>
                                </tr>
                            </NestedField>
                        ))}
                    </tbody>
                </table>
            </Box>

            {smallScreen ? addButton : null}
        </Fieldset>
    );
}
